package horcrux.frontend.common.views.components.input

import arrow.core.toOption
import horcrux.frontend.common.MaybeState
import horcrux.frontend.common.configs.StaticContentConfigs
import horcrux.frontend.common.views.components.containers.VStack
import mui.material.Input
import mui.material.InputProps
import mui.material.Typography
import mui.material.styles.TypographyVariant
import mui.system.sx
import react.FC
import react.Props
import react.dom.html.ReactHTML.p
import web.cssom.Color
import web.file.File
import web.html.HTMLInputElement

external interface FileInputProps : Props {
    var onFileChange: (File) -> Unit
    var errorTextMaybe: String?
    var inputProps: InputProps
}

val FileInput = FC<FileInputProps> { props ->
    VStack {
        Input {
            +props.inputProps
            +"Select a File"
            this.type = "file"
            this.onChange = { event ->
                val htmlInputElement = event.target as HTMLInputElement
                htmlInputElement.files.toOption().flatMap { it.item(0).toOption() }.onSome {
                    props.onFileChange(it)
                }
            }
        }
        props.errorTextMaybe?.let {
            Typography {
                +it
                this.variant = TypographyVariant.caption
                this.sx {
                    this.color = StaticContentConfigs.RED
                }
            }
        }
    }
}
